var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDoubleLeft = function SvgDoubleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 16",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.955 7.888 6.853 4.008 6.853 3.944v-2.78l-1.94-1.164-6.917-4.009 6.918-3.943 1.94-1.164V0L7.807 3.944.955 7.888Zm8.857 0 6.853 4.008 6.918 3.944v-2.78l-2.004-1.164-6.853-4.009 6.853-3.943 2.004-1.164V0l-6.918 3.944-6.853 3.944Z"
  })));
};

export default SvgDoubleLeft;